import React from 'react'
import PropTypes from 'prop-types'
import { AppliedTooltip as Tooltip, PopoverContainer, BaseSpan } from '../AppliedTooltip/AppliedTooltip'

const popoverTop = (
    <PopoverContainer title="Emphasising Education" color="#0095FF">
        Educational attainment isn't strongly predictive of performance in a
        role, and may introduce bias. Be sure to only require education &amp;
        qualifications that are actually necessary
    </PopoverContainer>
)
// Maybe try &quot;comfort with&quot;, &quot;ability to&quot;, or &quot;expertise in&quot;
class EducationSpan extends React.Component {
    render() {
        return (
            <span>
                <Tooltip
                    popoverContent={popoverTop}
                    disabled={!this.props.user.userId}
                >
                    <BaseSpan
                        offsetKey={this.props.offsetKey}
                        disabled={!this.props.user.userId}
                        color="#B9E6FF"
                        borderColor="#0095FF"
                    >
                        {this.props.children}
                    </BaseSpan>
                </Tooltip>
            </span>
        )
    }
}

EducationSpan.propTypes = {
    children: PropTypes.array,
}

export default EducationSpan
